import { useCallback } from 'react';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { aiExperiencePromptActionPluginKey } from '../../../../pm-plugins/prompt-action/prompt-action-plugin-key';
import { ACTIONS } from '../../../../pm-plugins/prompt-action/states';
import type { ActionType, ActionSource } from '../../../../pm-plugins/prompt-action/states';

export const useShowActionFlag = (editorView: EditorView) => {
	return useCallback(
		(actionTitle: ActionType, prompt: string, actionSource: ActionSource) => {
			// Dispatch transaction directly to update plugin state
			const tr = editorView.state.tr;
			tr.setMeta(aiExperiencePromptActionPluginKey, {
				type: ACTIONS.ACTION_COMPLETED,
				data: {
					actionType: actionTitle,
					prompt,
					actionSource,
				},
			});

			editorView.dispatch(tr);
		},
		[editorView],
	);
};
